export const MPTG_PER_PTG = 1000
